import { type UseDisclosureProps } from '@chakra-ui/react'

import Modal from 'components/modal'

import { useDeleteCustomerStream } from 'api'
import theme from 'theme'

import type { Dispatch, SetStateAction } from 'react'
import type { Stream } from 'types'

type Props = {
  streamDeleting: Stream | null
  setStreamDeleting: Dispatch<SetStateAction<Stream | null>>
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
  isOrphan?: boolean
  onContinue?: () => void
} & UseDisclosureProps

const DeleteStreamAlert = ({
  isOpen,
  onClose,
  onContinue,
  streamDeleting,
  setStreamDeleting,
  isLoading,
  setIsLoading,
  isOrphan,
}: Props) => {
  const { mutateAsync: deleteStreamRequest } = useDeleteCustomerStream(streamDeleting?.streamConfig?.streamGuid ?? '')

  const deleteStream = async () => {
    if (!streamDeleting?.streamConfig?.streamGuid) return
    setIsLoading(true)
    await deleteStreamRequest()
    if (onClose && !onContinue) onClose()
    setStreamDeleting(null)
    setIsLoading(false)
    if (onContinue) onContinue()
  }

  return (
    <Modal
      id="deleteStream"
      title="Delete stream"
      message={
        isOrphan
          ? 'This stream has no match. This can happen if a match is cancelled or postponed after the stream was already created. Do you wish to delete this stream?'
          : `Deleting a stream cannot be undone. Are you sure?`
      }
      buttons={[
        {
          text: 'No, go back',
          type: 'regress',
          color: theme.baseColors.primary.main,
          onClick: onClose,
        },
        {
          text: 'Yes, delete stream',
          type: 'progress',
          onClick: deleteStream,
          isLoading: isLoading,
        },
      ]}
      isOpen={isOpen ?? false}
      isLoading={isLoading}
      onClose={() => {
        if (onClose) onClose()
      }}
    />
  )
}

export default DeleteStreamAlert
